import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Login from "./pages/Login";
import AdminDashboard from "./pages/admin/AdminDashboard";
import UserDetails from "./pages/admin/UserDetails";
import VIPDashboard from "./pages/vip/VIPDashboard";
import PrivateRoute from "./components/PrivateRoute";

const App = () => {
  const [currentUser, setCurrentUser] = useState(null);

  // Load user from sessionStorage on app start
  useEffect(() => {
    const storedUser = sessionStorage.getItem("currentUser");
    if (storedUser) setCurrentUser(JSON.parse(storedUser));
  }, []);

  return (
    <Router>
      <Routes>
        {/* Login */}
        <Route
          path="/login"
          element={<Login setCurrentUser={setCurrentUser} />}
        />

        {/* Admin: User List */}
        <Route
          path="/admin/users"
          element={
            <PrivateRoute roles={["admin"]} currentUser={currentUser}>
              <AdminDashboard />
            </PrivateRoute>
          }
        />

        {/* Admin: User Details */}
        <Route
          path="/admin/users/:id"
          element={
            <PrivateRoute roles={["admin"]} currentUser={currentUser}>
              <UserDetails />
            </PrivateRoute>
          }
        />

        {/* VIP Dashboard */}
        <Route
          path="/vip/dashboard"
          element={
            <PrivateRoute roles={["vip"]} currentUser={currentUser}>
              <VIPDashboard currentUser={currentUser} />
            </PrivateRoute>
          }
        />

        {/* VIP Consumption by Medicine Report */}
        <Route
          path="/vip/report/medicine"
          element={
            <PrivateRoute roles={["vip"]} currentUser={currentUser}>
              <VIPDashboard page="medicine" currentUser={currentUser} />
            </PrivateRoute>
          }
        />

        {/* VIP Consumption by Patient Report */}
        <Route
          path="/vip/report/patient"
          element={
            <PrivateRoute roles={["vip"]} currentUser={currentUser}>
              <VIPDashboard page="patient" currentUser={currentUser} />
            </PrivateRoute>
          }
        />


        {/* Default / Fallback */}
        <Route
          path="*"
          element={<Login setCurrentUser={setCurrentUser} />}
        />
      </Routes>
    </Router>
  );
};

export default App;
